import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Component, ViewChild ,OnInit,Renderer2,ChangeDetectorRef,OnDestroy, DoCheck, ElementRef} from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { CellClickedEvent, ColDef, GridReadyEvent } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { Router,ActivatedRoute,NavigationEnd} from '@angular/router';
import { ICellRendererParams ,GridOptions} from 'ag-grid-community';
import {map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/Core/services/auth.service';
import { DeviceService } from 'src/app/Core/services/devices.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';



@Component({
  selector: 'app-device-list',
  templateUrl: './device-list-ctl.component.html'
})
export class DeviceListComponent implements OnDestroy{
  rowDataArray:any[]=[];
  devices: any[] = [];
  displayedDevices: any[] = [];
  currentPage = 1;
  pageSize = 10;
  deviceID: any;
  key: any;
  filter: string = 'serial';
  q: string = '';
  model: string = 'wifidetector';
  searchData: any[] = [];
  deviceDetails : any;
  API: any;
  searchForm : FormGroup;
  queryValue: any;
  private apiURL='';
  pageSizeOptions: number[] = [5, 10, 15, 20];
  defaultPlaceholder: string="10 items per page";
  dataFetched: boolean = false;

 @ViewChild('search_field', { static: true })
  search_field!: ElementRef;
  
  ngOnDestroy() {
  this.q='';
  this.search_field.nativeElement.value = "";
  }

  
totalItems: number = 0;
  get totalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }
  rowData: any[]=[];
  gridOptions: GridOptions = {};
  
  navigateToDeviceDetails(deviceID: string, locationID?: string) {
    this.router.navigate(['/device-details/locationId', locationID, 'device', deviceID]);
}

navigateToLocationDetails(locationID:string){
  this.router.navigate(['/location',locationID])
}
 
  public rowData$!: Observable<any[]>;
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  constructor(private http: HttpClient, private router: Router,private route: ActivatedRoute, private AuthService: AuthService,private renderer: Renderer2, private deviceService: DeviceService,private changeDetectorRef: ChangeDetectorRef,private formBuilder: FormBuilder) {
    this.key=this.AuthService.getToken();

    this.searchForm = this.formBuilder.group(
      {
        q: [''] // 'searchQuery' is the name of the FormControl
      }
    );
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Route has changed, reset the search query
        this.q = '';
       
        this.changeDetectorRef.detectChanges();
      }
    });
    
  }
  searchDevices(query: string): void {
    if (!query.trim()) {
      this.rowData = [];
      this.dataFetched=true;
      return;
    }
    if (this.filter === 'id') {
      this.deviceService.getDeviceData(query).subscribe(
        (data) => {
          if (data) {
            this.rowData = [data];
            this.dataFetched = true;
          } else {
            this.rowData = [];
            this.dataFetched = true;
          }
        },
        (error) => {
          console.error('Error fetching device details:', error);
          this.rowData = [];
          this.dataFetched = true;
        }
      );
    } else {
      this.currentPage = 1;
      this.searchDevicesBySerial(query, this.currentPage);
    }
  }
  
  searchDevicesBySerial(query: string, page: number): void {
    if (!this.isValidSerialNo(query)) {
      alert('Please enter a valid serial no.');
      return;
    }
    this.deviceService.getDeviceDatBySerial(query, page).subscribe(
      (data) => {
        if (data != null) {
          this.devices = data;
          if (this.devices.length) {
            this.totalItems = this.devices.length;
            this.pageSize = this.devices.length > 5 ? 5 : this.devices.length;
            this.paginateDevices();
          } else {
            this.rowData = [];
            this.dataFetched = true;
          }
        } else {
          this.rowData = [];
          this.dataFetched = true;
        }
      },
      (error) => {
        console.error('Error fetching device data:', error);
        this.rowData = [];
        this.dataFetched = true;
      }
    );
  }

  isValidSerialNo(serialNo: string): boolean {
    // Regular expression for Serial number validation
    const serialNoRegex = /^[a-zA-Z0-9]+$/;
    return serialNoRegex.test(serialNo);
  }

  paginateDevices(): void {
    const startIndex = (this.currentPage-1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayedDevices = this.devices.slice(startIndex, endIndex);
    this.rowData = this.displayedDevices;
    this.dataFetched = true;
  }
  
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.paginateDevices();
    }
  }
  
  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.paginateDevices();
    }
  }
  
  goToPage(pageNumber: number): void {
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.currentPage = pageNumber;
      this.searchDevicesBySerial(this.q, this.currentPage); 
    }
  }
  
  onFilterChange(): void {
    this.dataFetched=false;
    this.q = '';
    this.rowData=[];
  }

fetchDeviceDetails(){
  this.deviceService.getDeviceDetails(this.deviceID).subscribe((data)=>{
    this.deviceDetails = data.items;
    if(this.deviceDetails != null){
      this.rowData=this.deviceDetails;
    }
  });
}
}
